export enum GanttNames {
  gantt = 'gantt',
  ganttVisual = 'ganttVisual',
  lookahead = 'lookahead',
  table = 'table',
  issues = 'issues',
  dailies = 'dailies',
}
